/**
 * Image Text Pack Section
 */

class ImageTextPack {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Initialization logic if needed
  }
}

// Initialize section when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageTextPack);
} else {
  initImageTextPack();
}

function initImageTextPack() {
  const sections = document.querySelectorAll('[data-section-type="w-image-text-pack"]');
  sections.forEach((section) => {
    new ImageTextPack(section);
  });
}

// Shopify section events
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-image-text-pack"]');
    if (section) {
      new ImageTextPack(section);
    }
  });
}
